<template>
    <div class="modal-legal-mentions z-10" :class="[visible ? 'block' : 'hidden']">
        <div class="absolute w-full h-full top-0 left-0 block bg-black opacity-40" @click.stop.prevent="hide()">

        </div>
        <div class="container modal-container shadow-2xl flex relative">
            <button id="close-btn" class="btn-close" @click.stop.prevent="hide()">x</button>
            <!-- <div class="border-r-4 p-4">
                <p>
                    <slot></slot>
                </p>
            </div>
            <div class="border-r-4 p-4">
                 <p>
                    <slot></slot>
                </p>
            </div> -->
            <div class="p-4">
                 <template v-for="content in $t('summary').getSummaryContent()">
                    <p :key="content.text" v-html="content.text"></p>
                </template>
                <!-- <template v-if="!$settings.portable">
                   <p v-html="$t('summary').getSummaryContent()[1].text_non_portable"></p>
                </template> -->
                 
                
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
            };
        },
        methods: {
            show() {
                const vm = this;
                //
                vm.visible = true;
            },
            hide() {
                const vm = this;
                vm.visible = false;
            },
        },
        mounted() {
            const vm = this;
            $eventbus.$on('modal-legal-mentions:show', vm.show);
        },
        beforeDestroy() {
            const vm = this;
            $eventbus.$off('modal-legal-mentions:show', vm.show);
        }, 
    }
</script>

<style lang="scss" scoped>
.modal-legal-mentions {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}

.btn-close {
    top: 0;
    right: 0;
    width: 60px;
    height: auto;
    line-height: 50px;
    color: #b9b9b9;
    font-size: 50px;
    font-weight: 100;
    font-family: sans-serif;
    position: absolute;
    cursor: pointer;
    display: none;
    opacity: 0;
    visibility: hidden;
}
.modal-container {
    top: 50%;
    left: 50%;
    width: 95%;
    transform: translate(-50%, -50%);
    position: absolute;
    z-index: 9999;
    background: white;
    padding: 3rem;
    @media screen and (min-width: 768px) {
        top: 50%;
        left: 50%;
        width: 80%;
    }
    @media screen and (min-width: 1280px) {
        top: 50%;
        left: 50%;
        width: 40%;
    }
     @media screen and (max-width: 1280px) and (orientation:landscape) {
        top: 50%;
        left: 50%;
        width: 95%;
        padding: 0;
    }
    @media screen and (max-width: 361px) {
        top: 50%;
        left: 50%;
        width: 95%;
        padding: 0;
    }
}
</style>